import React, { useState, useEffect } from 'react';
import { useSetStoreValue, useStore } from 'react-context-hook'
import { ImageBackground, View, ScrollView } from 'react-native'
import { Layouts } from '../../utils'
import Styles from '../../Styles'
import * as Logger from '../../utils/Logger/index'
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Text,  Left,  Right,  Body, List, ListItem, Thumbnail, Content, Picker, Form, Item, Label, Tab, Tabs, TabHeading } from 'native-base';
import { colorPalette } from '../../utils/Styles';
import * as DashboardData from '../../utils/TestData/DashboardData'
import * as ProfileData from '../../utils/TestData/ProfileData'

export default function SavedScreenMain({ navigation }) { 

    //adds the menu buttons to the header
    Layouts.StackNavigationHeader({navigation});

    //default store items for use in the screen
    const [platform] = useStore('platform')
    const [displayDesktop] = useStore('displayDesktop')
    const [enableConsoleLogging] = useStore('enableConsoleLogging')
    const [enableSentryLogging] = useStore('enableSentryLogging')
    const [enableAlertLogging] = useStore('enableAlertLogging')

    //saved screen data 
    const [savedList, setSavedList] = useState(DashboardData.matchData)
    const [profile, setProfile] = useState(ProfileData.profileData1)
    const [profilePics, setProfilePics] = useState(DashboardData.matchData)
    const [picCount, setPicCount] = useState(profilePics.length)


    return(
        <ImageBackground source={global.BackgroundImage} style={displayDesktop ? Styles.Typography.generalAppContainer.desktop : Styles.Typography.generalAppContainer.mobile}>
            <View style={Styles.Typography.SavedScreenStyle.container}>
                <View style={displayDesktop ? Styles.Typography.SavedScreenStyle.desktopListContainer : Styles.Typography.SavedScreenStyle.mobileListContainer}>
                    <Styles.Components.SavedGridComponent data={savedList} />
                </View>

                {displayDesktop === true ? (
                    <View style={Styles.Typography.FullProfileGeneral.savedContainer}>
                        <ScrollView style={{flex:1}} contentContainerStyle={{ flexGrow:0.5, flexDirection:'column', alignItems:'center', padding:0 }}>

                            <Styles.Components.FullProfileContainer 
                                name={profile.name.firstName}
                                catchphrase={profile.basicInfo.catchphrase}
                                profilePic={DashboardData.profilePic1}
                                profileData={profile}
                            />
                            
                            <Styles.Components.ProfilePicViewer 
                                profilePics={profilePics}
                                picCount={picCount}
                            />              

                        </ScrollView>
                        </View>   
                    ) : (
                        <View></View>
                    )}     

            </View>
        </ImageBackground>
    )
 }